import { render, staticRenderFns } from "./CreditPriceHistory.vue?vue&type=template&id=bd8ca9ca&scoped=true"
import script from "./CreditPriceHistory.vue?vue&type=script&lang=js"
export * from "./CreditPriceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ca9ca",
  null
  
)

export default component.exports